import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=2226f9ee&scoped=true&"
var script = {}
import style0 from "./terms.vue?vue&type=style&index=0&id=2226f9ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2226f9ee",
  null
  
)

export default component.exports